// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const VideoPlaylistCard: MarkdocTagRegistration = {
  tag: 'video-playlist-card',
  component: 'VideoPlaylistCard',
  description: 'Render a video playlist in a card',
  attributes: {
    playlist: {type: String, required: true},
    href: {type: Href, required: true},
  },
};
